import React, { useState } from 'react'
import SectionTitle from '../components/section-title'
import Widget from '../components/widget'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { Button , Container, Row, Col, Form } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import { parseCookies } from 'nookies';

const AddZone = () => {
    //Setto gli state
    const [isCreated, setCreated] = useState(false)
    const [user, setUser] = useState(null)
    const [showErr, setErr] = useState('')
    const [showSucc, setSucc] = useState('')
    const { register, handleSubmit, errors } = useForm();
    const cookies = parseCookies()

    //Chiamata post per inserimento cliente
    const onSubmit = data => {
        const nome_zona = data.nome_zona.toUpperCase().trim( );

        axios.post(`${window.$apiEndpoint}/products/createZona`, {

            nome_zona: nome_zona,

        }, {
            headers: {
                'x-access-token' : cookies.token
            }
        })
            .then(res => {
                setUser(res.data)
                //Setto un Timeout per la risposta
                setTimeout(() => {setCreated(true)},2500)
                setSucc('Categoria creata con successo.')
            }).catch(err => {
                setErr('La zona risulta essere già esistente - ' + err.message)
            })
    }

    //Se lo state isCreated é true eseguo il redirect alla pagina profilo utente
    if (isCreated) {
        // redirect to home if signed up
        //Sleep 1
        return window.location.reload();
    }


    return (
        <>
            <SectionTitle title="Inserisci" subtitle="Crea nuova zona" />



                <Container fluid>
                        <Row>
                        <Col xs={12}>
                        <div className="card border-left-warning  shadow h-100 py-6 px-4">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Form.Row>

                                        <Form.Group  controlId="nome_zona" as={Col} >
                                        <Form.Label>Nome Zona</Form.Label>
                                        <Form.Control type="text" name="nome_zona" ref={register({ required: true })} placeholder="Inserisci Nome Zona" />
                                        {errors.nome_zona && <p style={{ marginTop: '1vh', fontWeight: 'bold', color: '#f15a24' }}>Il campo è obbligatorio</p>}
                                        </Form.Group>

                                    </Form.Row>


                                    <p className="my-2"  style={{ fontWeight: 'bold', color: 'red' }}>{showErr}</p>
                                    <p className="my-2"  style={{ fontWeight: 'bold', color: 'green' }}>{showSucc}</p>


                                    <Button variant="info" size="md" type="submit" style={{ backgroundColor: "rgb(103 103 102)", borderColor: "rgb(103 103 102)", fontWeight: '600'}}>
                                    Crea Zona
                                </Button>
                                    </Form>
                        </div>

                                </Col>

                            </Row>

                        </Container>
        </>
    )
}
export default AddZone
